/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Fav Order maintanance page component. The component displays the Fav Order maintanance page details.
 * 
 * App Name: SDI-Walmart
 * Author: Chandrasekar
 * Created Date: 08/13/2020 
 */
import React, { Component } from 'react';
import * as CookieService from '../CookieService';
/**
 * Ref: FOM_PC_01
 * Importing the action and store file and set to an object.
 */
import * as FavOrderMainAction from '../actions/FavOrderMainAction';
import FavOrderMainStore from '../stores/FavOrderMainStore';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Image from 'react-image-resizer';
import * as MenuAction from '../actions/MenuAction';
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next';
//[2/16/22], WW-330, Dhevanesam R
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import { fontSize } from '@material-ui/system';
import MultiSelect from "react-multi-select-component";
import Select from 'react-select'
import ShowMoreText from "react-show-more-text";
import swal from 'sweetalert';
let searchTxt = "";
let currentPagePath;
let isPostBack = true;
let isPrioritySearch = false;
let cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
class FavOrderMainComponent extends Component {
    /**
     * Ref: FOM_PC_03
     * Define the constructor that takes props as parameter
     * 
     * @param props
     */
    constructor(props) {
        super(props);
        /**
         * Ref: FOM_PC_05
         * Set the initial values of the state variables
         */
        this.state = {
            favOrderArray: [],
            favOrderLineItemData: [],
            totalCount: 0,
            pageNo: 1,
            itemCount: 10,
            pageCount: 0,
            isSearch: false,
            searchColumn: "ALL",
            sortColumn: "LAST_UPDATE_DTTM",
            sortValue: "DESC", sortVal: "S",
            filterDisplayName: "All",
            isFavorited: false,
            deleteID: "",
            isPageLoadedOnce: false,
            priorityFlag: 0, BckOrd: [], BckLine: [],//WAL-541-PC_23-Aparna
            UserDD: [], SelectedUser: [], RegionDD: [], SelectedRegion: [], EMPDD: [], SharededOrderNO: ""
            , ImageFileName: "", ImageFilePath: "", attachmentPathArrImg: "", EditIndex: "", CurrentOrderNo: "", CategoryShare: [], CategoryArr: [],//WAL-714 update
            multiDelete: true, SelectAll: true, //WW-419_PC_
            SelectedCategory: "", SelectedCatIndex: "", showCoreCharge: false, CoreChargeOrderNo: "", //A1QA-248_PC_01
            cartConfirmationPopupTxt: "" //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        };
        cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        this.assignFavOrderData = this.assignFavOrderData.bind(this);
        this.onAccordianClick = this.onAccordianClick.bind(this);
        this.filterClick = this.filterClick.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchTxt = this.handleSearchTxt.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.sortingClick = this.sortingClick.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleItemCheckbox = this.handleItemCheckbox.bind(this);
        this.addFavOrderItemsToCart = this.addFavOrderItemsToCart.bind(this);
        this.cartOrderSuccess = this.cartOrderSuccess.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteFavOrder = this.deleteFavOrder.bind(this);
        this.deleteResponse = this.deleteResponse.bind(this);
        this.handlePriority = this.handlePriority.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
        this.warehouseqtyresponse = this.warehouseqtyresponse.bind(this);
        this.ShareButtonClickResponse = this.ShareButtonClickResponse.bind(this);
        this.loadAttachmentsImg = this.loadAttachmentsImg.bind(this);
        this.EditClickResponse = this.EditClickResponse.bind(this);
        this.DeleteMultipleOrderResponse = this.DeleteMultipleOrderResponse.bind(this);
    };

    /**
    * Ref: FOM_PC_06
    * componentWillMount method will be first method which will be invoked
    * when Favorite order maintanance page is loaded
    */
    componentDidMount() {
        /**
        * Ref: FOM_PC_07
        * Invoke the action to get the page load data from API.
        */
        
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        isPostBack = true;
        $("#priorityDiv").hide();
        this.pageLoad(this.state.pageNo,
            this.state.itemCount,
            "",
            "",
            this.state.sortColumn,
            this.state.sortValue
        );
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        FavOrderMainAction.getCurrentFavPage(getFavPageBO);
        /**
        * Ref: FOM_PC_09
        * Define the listener methods
        */
        FavOrderMainStore.on('favOrderload', this.assignFavOrderData);
        FavOrderMainStore.on('favpage', this.loadFavPageResponse);
        FavOrderMainStore.on('updateFavPage', this.updateFavPageResponse);
        FavOrderMainStore.on('addFavOrder', this.cartOrderSuccess);
        FavOrderMainStore.on('dltFavOrder', this.deleteResponse);
        //[2/16/22], WW-330, Dhevanesam R
        ShoppingCartStore.on('Warehousecheck', this.warehouseqtyresponse);
        //WAL-714
        FavOrderMainStore.on('Share', this.ShareButtonClickResponse);
        //WW-375 Ability to add Image to Fav Order - Deepthi
        FavOrderMainStore.on('NONCAT_UploadAttachments2', this.loadAttachmentsImg);
        FavOrderMainStore.on('FavOrder_UpdateImg', this.EditClickResponse);
        FavOrderMainStore.on('MultiDeleteOrder', this.DeleteMultipleOrderResponse);//WW-419_PC_14
    };
    componentWillUnmount() {
        FavOrderMainStore.removeListener('favOrderload', this.assignFavOrderData);
        FavOrderMainStore.removeListener('favpage', this.loadFavPageResponse);
        FavOrderMainStore.removeListener('updateFavPage', this.updateFavPageResponse);
        FavOrderMainStore.removeListener('addFavOrder', this.cartOrderSuccess);
        FavOrderMainStore.removeListener('dltFavOrder', this.deleteResponse);
        //[2/16/22], WW-330, Dhevanesam R
        ShoppingCartStore.on('Warehousecheck', this.warehouseqtyresponse);
        //WAL-714
        FavOrderMainStore.removeListener('Share', this.ShareButtonClickResponse);
        //WW-375 Ability to add Image to Fav Order - Deepthi
        FavOrderMainStore.removeListener('NONCAT_UploadAttachments2', this.loadAttachmentsImg);
        FavOrderMainStore.removeListener('FavOrder_UpdateImg', this.EditClickResponse);
        FavOrderMainStore.removeListener('MultiDeleteOrder', this.DeleteMultipleOrderResponse);
    }
    /**
    * Ref: FOM_PC_26
    * Listener method for delete response
    */
    deleteResponse = () => {
        let deleteResponse = JSON.parse(FavOrderMainStore.deleteResponse)[0];
        if (deleteResponse.Success.toLowerCase() == "true") {

            $(`#searchTxt`).val("");
            let pageNo = 1;
            isPostBack = true;
            this.pageLoad(pageNo,
                this.state.itemCount,
                "",
                "",
                this.state.sortColumn,
                this.state.sortValue
            );
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Favorite order deleted successfully'
            });
            //  alert('Favorite order deleted successfully');
            this.setState({ pageNo: pageNo, sortColumn: "LAST_UPDATE_DTTM", sortValue: "DESC", filterDisplayName: "All" });
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in removing favorite order"
            });
            // alert("Error in removing favorite order");
        }
    };
    /**
    * Ref: FOM_PC_26
    * Listener method for adding cart items response
    */
    cartOrderSuccess = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let addFavOrderdataRes = JSON.parse(FavOrderMainStore.cartOrderSuccess);
        if (addFavOrderdataRes) {
            if (addFavOrderdataRes.Table1.length > 0) {
                addFavOrderdataRes = addFavOrderdataRes.Table1[0];
                if (addFavOrderdataRes.is_Success == "True") {
                    //this.props.history.push({
                    //    pathname: '/shoppingcart',
                    //});

                    // window.location.reload();
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item is added to cart successfully!"
                    });
                    // alert("Item is Added to cart Successfully!");
                    //BUG_2570_PC_01
                    this.pageLoad(this.state.pageNo,
                        this.state.itemCount,
                        "",
                        "",
                        this.state.sortColumn,
                        this.state.sortValue
                    );
                } else {
                    CookieService.updateLocalStorageValues("Session_CARTFAIL", addFavOrderdataRes.Session_CARTFAIL);
                }
            }
        }
    };
    /**
    * Listener method for the response of Save/Delete favorite page
    */
    updateFavPageResponse = () => {
        if (FavOrderMainStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(FavOrderMainStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(FavOrderMainStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        MenuAction.refreshMasterData()
    };
    /**
    * Handle change method for favorite page checkbox
    * @param event
    */
    handleFavorite = (event) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ isFavorited: event.target.checked });
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Favorite Order Maintenance",//WW-243 Fav Pages Sync Issue - Deepthi
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            FavOrderMainAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            FavOrderMainAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /**
    * Listener method for loading favorite page icon
    */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(FavOrderMainStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    /**
    * Reusable method for getting fav order details 
    */
    pageLoad = (pageNo, itemCount, searchColumn, searchText, sortColumn, sortValue) => {
        let pageLoadBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            pageNo: pageNo,
            itemCount: itemCount,
            searchColumn: searchColumn,
            searchText: searchText.replaceAll("'", "''"),
            sortColumn: sortColumn,
            sortValue: sortValue,
            Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
            ThirdParty_CompanyID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"),
            HOME_STORE: CookieService.getLocalStorageValues("HOME_STORE") //CPW-167_PC_05
        };
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        FavOrderMainAction.getFavOrderDetails(pageLoadBO);
    };
    /**
     * Ref: FOM_PC_14
     * Listener method for loading favorite order data
     */
    assignFavOrderData = () => {
        
        let pageLoadResponse = JSON.parse(FavOrderMainStore.pageLoadData);
        console.log("favOrderPageLoad-1", pageLoadResponse);
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        let tot = 0;

        if (pageLoadResponse.LineItemData) {
            pageLoadResponse.LineItemData.forEach((item, index) => {
                item.checked = false;
                let filteredItem = [];
                if (pageLoadResponse.LineItemImgData) {
                    filteredItem = pageLoadResponse.LineItemImgData.filter((x) => x.ORDER_NO == item.ORDER_NO && x.BUSINESS_UNIT_OM == item.BUSINESS_UNIT_OM && x.ISA_INTFC_LN == item.ISA_INTFC_LN);
                };
                if (filteredItem.length > 0) {
                    item.INV_ITEM_ID = filteredItem[0].ISA_ITEM;
                };
                //WW-368_PC_ 01
                if (item.ORDER_CATEGORY == " " || item.ORDER_CATEGORY == "" || item.ORDER_CATEGORY == null || item.ORDER_CATEGORY == undefined) {
                    item.ORDER_CATEGORY = "UNCLASSIFIED"
                }
                item.ORDER_CATEGORY = item.ORDER_CATEGORY.replaceAll("&apos;", "'")
                if (item.ORDER_SUBCATEGORY == " " || item.ORDER_SUBCATEGORY == "" || item.ORDER_SUBCATEGORY == null || item.ORDER_SUBCATEGORY == undefined) {
                    item.ORDER_SUBCATEGORY = "UNCLASSIFIED"
                }
                item.ORDER_SUBCATEGORY = item.ORDER_SUBCATEGORY //.toUpperCase().replaceAll("&APOS;", "'")
            });
        };
        let hd = []
        if (pageLoadResponse.HeaderData) {
            hd = pageLoadResponse.HeaderData
        }
        console.log("favOrderPageLoad-2", pageLoadResponse);
        //let GridArrResponse = []
        //GridArrResponse = pageLoadResponse.LineItemData;
        //GridArrResponse.forEach((value, index) => {
        //    //
        //    value.hasCoreCharge = false;
        //    value.disableCoreCharge = false;
        //    if (value.DESCR254.includes("Core Charges")) {
        //        //
        //        value.hasCoreCharge = true;                                                                
        //    }

        //});
        //[12/22/21], PC_OS_13, WW-286, Dhevanesam R
        //let GridArrResponse = []
        //GridArrResponse = pageLoadResponse.LineItemData;
        //GridArrResponse.forEach((value, index) => {
        //    //
        //    value.hasCoreCharge = false;
        //    if (value.DESCR254.includes("Core Charges")) {
        //        //
        //        //GridArrResponse.splice(index, 1);
        //        value.hasCoreCharge = true;
        //        //GridArrResponse[index - 1].hasCoreCharge = true;
        //    }

        //}); 
        //console.log("GridArrResponse-favord", GridArrResponse);
        //[3/9/22], PC_FO_1, A1QA-144, Dhevanesam R
        let GridArrResponse = []
        let GridArrResponse2 = []
        GridArrResponse = pageLoadResponse.LineItemData;
        GridArrResponse2 = pageLoadResponse.LineItemData;
        GridArrResponse.forEach((value, index) => {
            //
            value.hasCoreCharge = false;
        });
        GridArrResponse2.forEach((value, index) => {
            //
            value.hasCoreCharge = false;
        });
        //
        GridArrResponse.forEach((value, index) => {
            //
            if (value.DESCR254.includes("Core Charges")) {
                //
                GridArrResponse2.forEach((value2, index2) => {
                    //
                    let itemIDCC = GridArrResponse[index].INV_ITEM_ID.substring(7, GridArrResponse[index].INV_ITEM_ID.length)
                    if (GridArrResponse2[index2].INV_ITEM_ID == itemIDCC) {
                        //
                        GridArrResponse2[index2].hasCoreCharge = true;
                    }

                });

            }

        });
        GridArrResponse2.forEach((value, index) => {
            //
            if (value.DESCR254.includes("Core Charges")) {
                //
                GridArrResponse2.splice(index, 1);
            }
        });
        GridArrResponse = GridArrResponse2
        console.log("GridArrResponse-favord", GridArrResponse);
        //[2/16/22], WW-330, Dhevanesam R
        let checkqty = false
        GridArrResponse.forEach((value, index) => {
            value.hasBenItemVal = "";
            value.InvItemQtyCheck = false
            value.SubCatcheck = false
        });
        //
        //if (localStorage.getItem("StoreValue") != undefined || localStorage.getItem("StoreValue") != null) {
        //BenStoreVal = JSON.parse(localStorage.getItem("StoreValue"));
        let warehouse_item = GridArrResponse.filter((x) => x.VENDOR_ID == "W999999999")
        let loacalloc = JSON.parse(localStorage.getItem("StoreValue"))

        if (warehouse_item.length > 0) {
            checkqty = true;
        }
        if (checkqty) {
            let itemids = []
            warehouse_item.map((val, index) => {
                //
                itemids.push(val.INV_ITEM_ID)
            });
            if (itemids.length > 0) {
                //
                let BO = {
                    shipto_id: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",//loacalloc, WLA-767-Aparna
                    supplier_part_number: itemids,
                    User_Id: CookieService.getLocalStorageValues("Session_UserID")
                }
                //
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ShoppingCartAction.WarehouseQTYCheck(BO)
            }

        }
        //}
        //WAL-541_PC_24 -Aparna
        let category = []
        let HeaderData = pageLoadResponse.HeaderData;
        //if (HeaderData != null && HeaderData != undefined) {
        //    if (HeaderData.length > 0) {
        //        CookieService.updateLocalStorageValues("FavOrder_Category", HeaderData);
        //    }

        //}
        HeaderData.forEach((value, index) => {
            if (value.ORDER_CATEGORY == " " || value.ORDER_CATEGORY == "" || value.ORDER_CATEGORY == null) {
                value.ORDER_CATEGORY = "UNCLASSIFIED"
            }
            value.IsEditClicked = false;
            value.EditedImage = "";
            value.checked = false;
            value.ReorderCheck = false;
            value.SubCatcheck = false;
        });

        if (hd != undefined) {
            category = hd.filter((v, i, a) => a.findIndex(t => (t.ORDER_CATEGORY.trim() === v.ORDER_CATEGORY.trim())) === i)
            console.log("cattttt", category)
            tot = category.length
        }
        let count = parseFloat(category.length) / 10
        //WAL-714_PC_16 update
        let catpush = []

        if (category != undefined) {
            category.forEach((value, index) => {
                //if (value.ORDER_CATEGORY == " " || value.ORDER_CATEGORY == "" || value.ORDER_CATEGORY == null) {
                //    value.ORDER_CATEGORY = "UNCLASSFIED"
                //}
                console.log("order_cat", value.ORDER_CATEGORY);
                catpush.push({
                    BUSINESS_UNIT: value.BUSINESS_UNIT,
                    EditedImage: value.EditedImage,
                    IMG_URL: value.IMG_URL,
                    FAV_ORDER_ID: value.FAV_ORDER_ID,
                    ISA_PRIORITY_FLAG: value.ISA_PRIORITY_FLAG,
                    ISA_WORK_ORDER_NO: value.ISA_WORK_ORDER_NO,
                    IsEditClicked: value.IsEditClicked,
                    OPRID_ENTERED_BY: value.OPRID_ENTERED_BY,
                    ORDERED_FOR: value.ORDERED_FOR,
                    ORDER_CATEGORY: value.ORDER_CATEGORY,
                    ORDER_SUBCATEGORY: value.ORDER_SUBCATEGORY,
                    ORDER_DESC: value.ORDER_DESC,
                    ORDER_NO: value.ORDER_NO,
                    check: false,
                    SubCatcheck: false
                });
            });
        }
        console.log("catpush", catpush);

        //WAL-714
        let locEMP = []
        let locREGDD = []
        let locReg = []
        if (pageLoadResponse.EmployeeCC != undefined && pageLoadResponse.EmployeeCC != null) {
            console.log("pageLoadResponse.EmployeeCC", pageLoadResponse.EmployeeCC)
            if (pageLoadResponse.EmployeeCC.length > 0) {
                pageLoadResponse.EmployeeCC.map((val, index) => {
                    if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                        let localArray = {
                            value: val.EMP_ID,
                            label: val.ISA_EMPLOYEE_NAME + " " + val.ISA_EMPLOYEE_EMAIL
                        }

                        locEMP.push(localArray)
                    }
                });
                console.log("pageLoadResponse.EmployeeCC", pageLoadResponse.EmployeeCC)
                locReg = pageLoadResponse.EmployeeCC.filter((v, i, a) => a.findIndex(t => (t.REGION === v.REGION && t.REGION != null && t.REGION != " ")) === i)
                locReg.map((val, index) => {
                    let localArray = {
                        value: val.REGION,
                        label: val.REGION
                    }

                    locREGDD.push(localArray)
                });

            }

        }

        console.log("region", locReg)
        console.log("at setstate", catpush)
        this.setState({
            favOrderArray: HeaderData, BckOrd: pageLoadResponse.HeaderData,
            favOrderLineItemData: GridArrResponse, BckLine: GridArrResponse,
            totalCount: pageLoadResponse.TotalCount.length > 0 ? pageLoadResponse.TotalCount[0].TOTAL_COUNT : 0,
            pageCount: count,//Math.ceil((tot.length > 0 ? tot : 0) / 10),
            isPageLoadedOnce: true,
            UserDD: locEMP, RegionDD: locREGDD, EMPDD: pageLoadResponse.EmployeeCC, CategoryArr: catpush//WAL-714
        });
        if (!checkqty) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        //WW-516_FI_PC_06 (10/14/2022)-Aparna
        //[1/25/23, WW-587_PC_8, Dhevanesam R]
        let locSelectedCat = "";
        let locSelectedCatIndex = 0;
        let searctxt = $(`#searchTxt`).val().toLowerCase();
        if (catpush.length > 0 && searctxt == "") {
            locSelectedCat = catpush[0]
            if (this.state.SelectedCatIndex != 0 && this.state.SelectedCatIndex != "") {
                locSelectedCatIndex = this.state.SelectedCatIndex
                locSelectedCat = category[locSelectedCatIndex]
            }
            else {
                if (CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != null && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != "" && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != undefined && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != " " && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != 0 && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != "0") {
                    locSelectedCatIndex = CookieService.getLocalStorageValues("SelectedCatIndexFavOrder")
                    locSelectedCat = category[locSelectedCatIndex]
                    CookieService.updateLocalStorageValues("SelectedCatIndexFavOrder", "");
                }
                else {
                    locSelectedCatIndex = 0
                    locSelectedCat = category[0]
                }
            }
        }
        else {
            if (CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != null && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != "" && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != undefined && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != " " && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != 0 && CookieService.getLocalStorageValues("SelectedCatIndexFavOrder") != "0") {
                locSelectedCatIndex = CookieService.getLocalStorageValues("SelectedCatIndexFavOrder")
                locSelectedCat = category[locSelectedCatIndex]
                CookieService.updateLocalStorageValues("SelectedCatIndexFavOrder", "");
            }
            else {
                locSelectedCatIndex = 0
                locSelectedCat = category[0]
            }
        }
        //if (this.state.SelectedCatIndex != 0 && this.state.SelectedCatIndex != "") {
        //    locSelectedCatIndex = this.state.SelectedCatIndex 
        //}
        //WW-542_PC_07 (12/2/2022) -Aparna
        let locmenuFavOrder = CookieService.getLocalStorageValues("menuFavOrder");
        let categoryName = []
        let accordianOpenIndex = 0
        if (locmenuFavOrder != null && locmenuFavOrder != undefined && locmenuFavOrder != "") {
            console.log("menu- click order-No", locmenuFavOrder)
            console.log("favorderheader", HeaderData)
            categoryName = HeaderData.filter((x) => x.ORDER_NO == locmenuFavOrder)
            let catname = ""
            if (categoryName != undefined && categoryName != null) {
                catname = categoryName[0].ORDER_CATEGORY
                console.log("catname", catname)

            }
            locSelectedCatIndex = category.findIndex(elem => elem.ORDER_CATEGORY === categoryName[0].ORDER_CATEGORY)
            this.shiftingSubcategory(locmenuFavOrder)
        }
        if (locSelectedCatIndex != -1 && locSelectedCatIndex != null && locSelectedCatIndex != undefined) {
            locSelectedCat = category[locSelectedCatIndex]
        }
        else {
            locSelectedCatIndex = 0
        }
        this.SelectSubCategory("pageLoad", locSelectedCat.ORDER_CATEGORY, locSelectedCatIndex, locSelectedCat);
        if (locmenuFavOrder != null && locmenuFavOrder != undefined && locmenuFavOrder != "") {
            //let locindexForCSS = this.state.SubCategoryArr.findIndex(elem => elem.ORDER_NO === locmenuFavOrder)
            accordianOpenIndex = this.state.SubCategoryArr.findIndex(elem => elem.ORDER_SUBCATEGORY === categoryName[0].ORDER_SUBCATEGORY)
            $(`#Order-accordian${accordianOpenIndex}`).addClass('show')
            $(`#Span-accordian-change${accordianOpenIndex}`).toggleClass('accordion-arrow-change')

        }
        CookieService.updateLocalStorageValues("menuFavOrder", "");
        //BUG_2570    (9/2/2022)-Aparna
        this.SortingCat(this.state.sortVal)
    };
    //WW-542_PC_09 (12/5/2022)-Aparna
    shiftingSubcategory = (locmenuFavOrder) => {
        let { favOrderArray } = this.state;
        let locSortedFavOrderArray = []
        favOrderArray.forEach((x) => {
            if (x.ORDER_NO == locmenuFavOrder) {
                locSortedFavOrderArray.unshift(x)
            }
            else {
                locSortedFavOrderArray.push(x)
            }
        });
        this.setState({ favOrderArray: locSortedFavOrderArray });
    }
    //[2/16/22], WW-330, Dhevanesam R
    warehouseqtyresponse = () => {

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Workorderresponse = JSON.parse(ShoppingCartStore.workorderresponse);
        let local = Workorderresponse.Table
        let st = 0
        let GridArrResponse = this.state.favOrderLineItemData
        if (local.length > 0) {
            
            local.forEach((x) => {
                
                if (x.QTY != null) {
                    st = x.QTY.split('^')[0];
                    
                    console.log("hasBenItemVal", x.QTY.slice(-1))
                    GridArrResponse.forEach((value, index) => {
                        if (GridArrResponse[index].INV_ITEM_ID == x.INV_ITEM_ID) {
                            value.hasBenItemVal = x.QTY.slice(-1);
                            
                            if (st == 0) {
                                
                                value.InvItemQtyCheck = true
                            }
                        }

                    });
                }
            })
        }
        this.setState({
            favOrderLineItemData: GridArrResponse
        })
        
        console.log("GridArrResponseCribFavItem", GridArrResponse)
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    /**
     * Ref: FOM_PC_22
     * This method will be invoked on click of delete icon
     * @param deleteID
     */
    handleDelete = (deleteID) => {
        this.setState({ deleteID: deleteID, multiDelete: false });
    };
    /**
     * Ref: FOM_PC_20
     * This method will be invoked on click of sort icon
     * @param sortColumn,@param sortValue
     */
    sortingClick = (sortColumn, sortValue) => {
        console.log(sortColumn, sortValue);
        if (this.state.isSearch) {
            searchTxt = $(`#searchTxt`).val().trim();
        }
        isPostBack = false;
        let pageNo = 1;
        this.pageLoad(pageNo,
            this.state.itemCount,
            this.state.searchColumn,
            searchTxt,
            sortColumn,
            sortValue
        );
        this.setState({ pageNo: pageNo, sortColumn: sortColumn, sortValue: sortValue });
    }
    /**
    * Ref: FOM_PC_24
    * This method will be invoked on click of page number
    */
    handlePageClick = (data) => {
        let pageNo = data.selected + 1;
        this.setState({ pageNo: pageNo });
        //WAL-541_PC_25 -Aparna
        //if (this.state.isSearch) {
        //    if (isPrioritySearch) {
        //        let radioVal = $("input[name='priorityOption']:checked").val();
        //        if (radioVal == `1`)
        //            searchTxt = `R`;
        //        else
        //            searchTxt = ` `;

        //    } else {
        //        searchTxt = $(`#searchTxt`).val().trim();
        //    }
        //}
        //isPostBack = false;
        //this.pageLoad(pageNo,
        //    this.state.itemCount,
        //    this.state.searchColumn,
        //    searchTxt,
        //    this.state.sortColumn,
        //    this.state.sortValue
        //);
    };
    /**
    * Ref :FOM_PC_19
    * This method will be invoked on change of Priority radio button
    * @param event
    */
    handlePriority = (value) => {
        this.setState({ priorityFlag: value });
        let priorityFlag = ``;
        if (value == 1) {
            priorityFlag = `R`;
        } else {
            priorityFlag = ` `;
        }
        this.handleSearch(true, priorityFlag);
    }
    /**
     * Ref :FOM_PC_19
     * This method will be invoked on change of search textbox
     * @param event
     */
    handleSearchTxt = (event) => {
        this.setState({ isSearch: false });
    }
    /**
     *  Ref :FOM_PC_19
     * This method will be invoked on enter button click
     */
    keyPress(e) {
        if (e.keyCode == 13) {
            this.handleSearch(false, "");
        }
    };
    /*
     * Common method to refresh the master data in menu
     */
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true,//isFirstTimeLoaded
            HOME_STORE: CookieService.getLocalStorageValues("HOME_STORE"), //CPW-167_PC_06
        };
        console.log("masterBO", masterBO);
        MenuAction.getMasterData(masterBO);
    };
    /**
     * Ref:FOM_PC_23
     * This method will be invoked on yes button on delete confirmation popup
     */
    deleteFavOrder = () => {
        let deleteBO = {
            FAV_ORDER_ID: this.state.deleteID,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID")
        }
        this.refreshMenu();
        FavOrderMainAction.deleteFavOrder(deleteBO);

    };
    /**
    * Ref :FOM_PC_19
    * This method will be invoked on Search icon click
    */
    handleSearch = (isPriority, priorityFlag) => {
        let pageNo = 1;
        if (isPriority == true) {
            isPrioritySearch = true;
            searchTxt = priorityFlag;
        } else {
            isPrioritySearch = false;
            searchTxt = $(`#searchTxt`).val().trim();
            // searchTxt = searchTxt.replaceAll("'","''")
        }
        isPostBack = false;
        this.pageLoad(pageNo,
            this.state.itemCount,
            this.state.searchColumn,
            searchTxt,
            this.state.sortColumn,
            this.state.sortValue
        );

        this.setState({ pageNo: pageNo, isSearch: true });
    };
    /**
    * Ref :FOM_PC_21
    * This method is invoked when the Expand Order Button is click in the Order Level.
    * @param event,@param index
    */
    onAccordianClick = (event, index) => {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        //$(`#arrow-${index}`).children().toggleClass('accordion-arrow-change');
        //$(`#contentrow-${index}`).toggleClass('d-none');
        //$('tr').removeClass('tr-border');
        //$(event.currentTarget).parent('tr').addClass('tr-border');

    };
    //WW-375 Ability to add Image to Fav Order - Deepthi
    handleAttachmentImg = (event, index, OrderNo) => {
        
        let files = event.target.files;

        //WW-947 Attachment utility in fav order - Yuvarani K
        this.setState({ indexVal: index });
        //WW-375 Ability to add Image to Fav Order - Deepthi
        let acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        if (acceptedImageTypes.includes(files[0].type)) {
            console.log("event", files);
            if (files.length > 0) {
                let { favOrderArray } = this.state;
                //let index = this.state.favOrderArray.findIndex(elem => elem.ORDER_NO === OrderNo);
                this.state.favOrderArray[index].IsEditClicked = true;

                this.setState({ attachmentErrormsg: "", ImageFileName: files[0].name, favOrderArray: favOrderArray, CurrentOrderNo: OrderNo });

                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                FavOrderMainAction.addAttachmentImg(files);
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please choose only Image file "
            });
            // alert("Please choose only Image file ");
        }

    };
    //WW-375 Ability to add Image to Fav Order - Deepthi
    loadAttachmentsImg = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = FavOrderMainStore.NONCAT_UploadAttachments2.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(FavOrderMainStore.NONCAT_UploadAttachments2);
            //let tempAttachments = this.state.attachmentPathArrImg;
            //tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArrImg: attachmentResponse[0].FilePath });
            this.UpdateClick(this.state.CurrentOrderNo);
            //console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    onCancelClick = (e, OrderNo) => {
        let { favOrderArray } = this.state;
        let index = this.state.favOrderArray.findIndex(elem => elem.ORDER_NO === OrderNo);
        this.state.favOrderArray[index].IsEditClicked = false;
        this.setState({ favOrderArray: favOrderArray })
    };
    //WW-375 Ability to add Image to Fav Order - Deepthi
    UpdateClick = (OrderNo) => {
        
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let { favOrderArray } = this.state;

        //WW-947 Attachment utility in fav order - Yuvarani K
        let index = this.state.indexVal;
        this.setState({ EditIndex: index });
        let FavOrder_UpdateImgBO = {
            Order_No: OrderNo,
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            ImageFileBytes: this.state.attachmentPathArrImg,
            ImageFileName: this.state.attachmentPathArrImg,
            Business_Unit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            IsWeb: true
        }
        FavOrderMainAction.FavOrder_UpdateImg(FavOrder_UpdateImgBO);
    };
    //WW-375 Ability to add Image to Fav Order - Deepthi
    EditClickResponse = () => {
        

        let AddOrUpdateLocData = JSON.parse(FavOrderMainStore.FavOrder_UpdateImg);
        //WW-375 Ability to add Image to Fav Order - Deepthi
        let imgind = AddOrUpdateLocData.indexOf("Img");
        let ImgUrl = AddOrUpdateLocData.substring(imgind + 7, AddOrUpdateLocData.length);
        let favOrderArray = this.state.favOrderArray;
        //Bug 5004 After uploading the image, it is not reflected -Nandhini L
        if (this.state.favOrderArray[this.state.EditIndex].IMG_URL === "Images\noimage_new.png" || this.state.favOrderArray[this.state.EditIndex].IMG_URL === " " || this.state.favOrderArray[this.state.EditIndex].IMG_URL === "\N") {
            favOrderArray[this.state.EditIndex].IMG_URL = "";
        }
        favOrderArray[this.state.EditIndex].IMG_URL = ImgUrl;
        //WW-1063 after efitting the image while sharing it is not reflecting 26/07/2024 s.sanjay
        let updatedFavOrderLineItemData = this.state.favOrderLineItemData.map(item => {
            if (item.ORDER_NO === favOrderArray[this.state.EditIndex].ORDER_NO) {
                return { ...item, IMG_URL: ImgUrl };
            }
            return item;
        });

        // Update state
        this.setState({
            favOrderArray: favOrderArray,
            favOrderLineItemData: updatedFavOrderLineItemData
        });
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (AddOrUpdateLocData.includes("Success")) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Image updated successfully"
            });

            // alert("Image Updated Successfully");
        }

        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Updation Failed"
            });
            // alert("Updation Failed");
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    };
    //WAL-541_PC_26
    onAccordianClick1 = (event, index) => {
        // $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#arrowI-${index}`).toggleClass('accordion-arrow-change');
        // $(`accordian${index}`).children().toggleClass('accordion-arrow-change');
        $(`#contentrowI${index}-${index}`).toggleClass('d-none');
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');

    };
    /**
    * Ref :FOM_PC_17
    * This method is invoked when the checkbox of a item is selected
    * @param lineID,@param OrderNo
    */
    handleItemCheckbox = (lineID, OrderNO) => {
        let { favOrderLineItemData } = this.state;
        let { favOrderArray } = this.state;
        let index = favOrderLineItemData.findIndex(x => x.ORDER_NO == OrderNO && x.ISA_INTFC_LN == lineID);
        favOrderLineItemData[index].checked = favOrderLineItemData[index].checked == true ? false : favOrderLineItemData[index].checked == false ? true : true;
        this.setState(favOrderLineItemData);
        //let favorderarrycount = favOrderArray.filter((x) => x.ORDER_NO == OrderNO).length
        //WW-478_PC_02 (8/29/2022)-Aparna
        let favOrderLineItemDatacount = favOrderLineItemData.filter((x) => x.ORDER_NO == OrderNO).length
        let favOrderLineItemDatacountchecked = favOrderLineItemData.filter((x) => x.ORDER_NO == OrderNO && x.checked == true).length
        if (favOrderLineItemDatacount != favOrderLineItemDatacountchecked) {
            this.state.favOrderArray.forEach((y) => {
                if (y.ORDER_NO == OrderNO) {
                    y.ReorderCheck = false;
                }
            })
        }
        else {
            this.state.favOrderArray.forEach((y) => {
                if (y.ORDER_NO == OrderNO) {
                    y.ReorderCheck = true;
                }
            })
        }
        this.setState(favOrderArray)


    };
    //WW-478_PC_01 
    handleOrderCheckbox(OrderNO) {
        
        let { favOrderLineItemData } = this.state;
        let favOrderdata = this.state.favOrderArray.filter(x => x.ORDER_NO == OrderNO);
        let favorderboolean = false
        this.state.favOrderArray.forEach((y) => {
            if (y.ORDER_NO == OrderNO) {
                y.ReorderCheck = y.ReorderCheck == true ? false : true;
                favorderboolean = y.ReorderCheck
            }
        })
        favOrderLineItemData.forEach((x, index) => {
            if (x.ORDER_NO == OrderNO) {
                favOrderLineItemData[index].checked = favorderboolean;
            }

        })
        this.setState(favOrderLineItemData);
    };
    /**
    * Ref :FOM_PC_16
    * This method is invoked on change of quantity textbox
    * @param e,@param lineID,@param OrderNo
    */
    handleQuantityChange = (e, lineID, OrderNO) => {
        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value != "0") {
                let { favOrderLineItemData } = this.state;
                let index = favOrderLineItemData.findIndex(x => x.ORDER_NO == OrderNO && x.ISA_INTFC_LN == lineID);
                favOrderLineItemData[index].QTY_REQUESTED = e.target.value;
                this.setState(favOrderLineItemData);
            }
        }
    };
    /**
     * Ref :FOM_PC_14
     * This method is to bind the fav order line items
     * @param OrderNo
     */
    //WAL-714 update
    CategoryOnCheck = (type, item, boolean) => {
        let { CategoryArr } = this.state;
        let { SubCategoryArr } = this.state;
        let { favOrderArray } = this.state;
        
        if (type == "cat") {
            let I = CategoryArr.findIndex(t => (t.ORDER_CATEGORY === item.ORDER_CATEGORY))
            this.state.CategoryArr[I].check = CategoryArr[I].check == true ? false : CategoryArr[I].check == false ? true : true;
            this.state.favOrderArray.forEach((x, index) => {
                if (x.ORDER_CATEGORY == item.ORDER_CATEGORY) {
                    this.state.favOrderArray[index].checked = CategoryArr[I].check
                }
            })
            //BUG can remove it.
            let locsubcat = this.state.favOrderLineItemData.filter((val, ind) => val.ORDER_CATEGORY == item.ORDER_CATEGORY)
            console.log("favOrderLineItemData", this.state.favOrderLineItemData)
            SubCategoryArr = locsubcat.filter((v, i, a) => a.findIndex(t => (t.ORDER_SUBCATEGORY === v.ORDER_SUBCATEGORY)) === i)

            //WW-514_FI_PC_04 (10/14/2022)-Aparna K
            if (SubCategoryArr != [] && SubCategoryArr != undefined && SubCategoryArr != null) {
                SubCategoryArr.forEach((x, index) => {
                    if (x.ORDER_CATEGORY == item.ORDER_CATEGORY) {
                        SubCategoryArr[index].SubCatcheck = CategoryArr[I].check
                    }
                })
                this.setState(SubCategoryArr);
            }
            console.log("this.SubCategoryArr", this.state.SubCategoryArr)
            console.log("this.CategoryArr", this.state.CategoryArr)
            this.setState(CategoryArr);
        }
        else if (type == "SubCat") {
            let I = SubCategoryArr.findIndex(t => (t.ORDER_CATEGORY === item.ORDER_CATEGORY && t.ORDER_SUBCATEGORY === item.ORDER_SUBCATEGORY))
            SubCategoryArr[I].SubCatcheck = SubCategoryArr[I].SubCatcheck == true ? false : SubCategoryArr[I].SubCatcheck == false ? true : true;
            this.state.favOrderArray.forEach((x, index) => {
                if (x.ORDER_CATEGORY == item.ORDER_CATEGORY && x.ORDER_SUBCATEGORY === item.ORDER_SUBCATEGORY) {
                    this.state.favOrderArray[index].checked = SubCategoryArr[I].SubCatcheck
                }
            })

            //let subcatlen = SubCategoryArr.length
            let checkedsubcat = SubCategoryArr.filter((t) => (t.ORDER_CATEGORY == item.ORDER_CATEGORY && t.SubCatcheck == true))
            let In = CategoryArr.findIndex(t => (t.ORDER_CATEGORY == item.ORDER_CATEGORY))
            if (SubCategoryArr.length == checkedsubcat.length) {
                CategoryArr[In].check = true;
            }
            else {
                CategoryArr[In].check = false;
            }
            this.setState(SubCategoryArr);
            this.setState(CategoryArr);
        }
        else {
            console.log("catcat", favOrderArray)
            console.log("catcat", CategoryArr)
            let I = favOrderArray.findIndex(t => (t.ORDER_CATEGORY == item.ORDER_CATEGORY && t.ORDER_NO == item.ORDER_NO))
            favOrderArray[I].checked = favOrderArray[I].checked == true ? false : favOrderArray[I].checked == false ? true : true;
            let grid = favOrderArray.filter((x) => (x.ORDER_CATEGORY === item.ORDER_CATEGORY))
            let checkedgrid = favOrderArray.filter((t) => (t.ORDER_CATEGORY == item.ORDER_CATEGORY && t.checked == true))
            let In = CategoryArr.findIndex(t => (t.ORDER_CATEGORY == item.ORDER_CATEGORY))


            if (grid.length == checkedgrid.length) {
                CategoryArr[In].check = true;
            }
            else {
                CategoryArr[In].check = false;
            }

            let ordercheckedlen = favOrderArray.filter((t) => (t.ORDER_CATEGORY == item.ORDER_CATEGORY && t.ORDER_SUBCATEGORY == item.ORDER_SUBCATEGORY && t.checked == true))
            let orderlen = favOrderArray.filter((t) => (t.ORDER_CATEGORY == item.ORDER_CATEGORY && t.ORDER_SUBCATEGORY == item.ORDER_SUBCATEGORY))
            let SubIn = SubCategoryArr.findIndex(t => (t.ORDER_CATEGORY == item.ORDER_CATEGORY && t.ORDER_SUBCATEGORY == item.ORDER_SUBCATEGORY))
            if (ordercheckedlen.length == orderlen.length) {
                SubCategoryArr[SubIn].SubCatcheck = true;
            }
            else {
                SubCategoryArr[SubIn].SubCatcheck = false;
            }

            this.setState(favOrderArray);
            this.setState(SubCategoryArr);
            //this.setState(CategoryArr);
        }

    }
    //WW-419_PC_19 adding select all and unselect all functionality(6/8/2022) -Aparna
    SelectAllButtonClick = (e, SelectAll) => {
        let { favOrderArray } = this.state;
        let { CategoryArr } = this.state;
        let { SubCategoryArr } = this.state;
        if (SelectAll) {
            favOrderArray.forEach((x, i) => {
                this.state.favOrderArray[i].checked = true
            })
            CategoryArr.forEach((x, i) => {
                this.state.CategoryArr[i].check = true
            })
            SubCategoryArr.forEach((x, i) => {
                this.state.SubCategoryArr[i].SubCatcheck = true
            })
        }
        else {
            favOrderArray.forEach((x, i) => {
                this.state.favOrderArray[i].checked = false
            })
            CategoryArr.forEach((x, i) => {
                this.state.CategoryArr[i].check = false
            })
            SubCategoryArr.forEach((x, i) => {
                this.state.SubCategoryArr[i].SubCatcheck = false
            })
        }
        this.setState({ favOrderArray });
        this.setState({ CategoryArr });
        this.setState({ SubCategoryArr });
        this.setState({ SelectAll: this.state.SelectAll ? false : true });
    }

    bindFavOrderLineItems = (OrderNo) => {
        
        let childItems = this.state.favOrderLineItemData.filter((item, index) => item.ORDER_NO == OrderNo);
        console.log("childItems", childItems)
        return childItems.map((childItem, childindex) => {
            let RecSuppStr = "";
            let supplierstr = "";
            let valitemdesc = childItem.DESCR254;
            //WW-381 Description With Recommended Supplier and Supplier has to be Removed - Deepthi
            if (childItem.DESCR254 != null || childItem.DESCR254 != undefined) {
                childItem.DESCR254 = childItem.DESCR254.includes("&apos;") ? childItem.DESCR254.replaceAll("&apos;", "'") : childItem.DESCR254; //BUG-2628 (9/9/2022)-Aparna
                if (!childItem.DESCR254.toUpperCase().includes("SUPPLIER")) {
                    valitemdesc = childItem.DESCR254;
                    if (childItem.LINE_FIELD_C6 == "NSTK") {
                        RecSuppStr = childItem.RECSUPPLIER;
                    }
                    else {
                        supplierstr = childItem.SUPPLIER;
                    }
                }
                else if (childItem.DESCR254.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                    let ind = childItem.DESCR254.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                    let recind = childItem.DESCR254.indexOf(":");
                    RecSuppStr = childItem.DESCR254.substring(recind + 1, childItem.DESCR254.length);
                    let lastlen = childItem.DESCR254.length;
                    let removedreco = childItem.DESCR254.slice(0, ind);
                    valitemdesc = removedreco.includes("&apos;") ? removedreco.replaceAll("&apos;", "'") : removedreco; //BUG-2628 (9/9/2022)-Aparna
                }
                else if (childItem.DESCR254.toUpperCase().includes("SUPPLIER:")) {
                    let ind = childItem.DESCR254.toUpperCase().indexOf("SUPPLIER");
                    let supind = childItem.DESCR254.indexOf(":");
                    if (childItem.SUPPLIER != "" && childItem.SUPPLIER != null && childItem.SUPPLIER != undefined) {
                        supplierstr = childItem.SUPPLIER;
                    }
                    else {
                        supplierstr = childItem.DESCR254.substring(supind + 1, childItem.DESCR254.length);
                    }
                    let lastlen = childItem.DESCR254.length;
                    let removedreco = childItem.DESCR254.slice(0, ind);
                    valitemdesc = removedreco.includes("&apos;") ? removedreco.replaceAll("&apos;", "'") : removedreco; //BUG-2628 (9/9/2022)-Aparna
                }
                else {
                    supplierstr = "";
                    RecSuppStr = "";
                    valitemdesc = childItem.DESCR254.includes("&apos;") ? childItem.DESCR254.replaceAll("&apos;", "'") : childItem.DESCR254; //BUG-2628 (9/9/2022)-Aparna
                }
            }

            if (childItem.DESCR254 != null || childItem.DESCR254 != undefined) {
                if (childItem.DESCR254.toUpperCase().includes("-INVITEMICON-")) {
                    /*[06/13/22,WW-401], Priyanka D */
                    valitemdesc = childItem.DESCR254.split("-INVITEMICON-")
                    valitemdesc = valitemdesc[0].includes("&apos;") ? valitemdesc[0].replaceAll("&apos;", "'") : valitemdesc[0]; //BUG-2628 (9/9/2022)-Aparna;
                }

            }
            console.log("RecSuppStr", RecSuppStr)
            //WW-241_PC_01
            if (RecSuppStr == undefined) {
                RecSuppStr = ""
            }
            if (supplierstr == undefined) {
                supplierstr = ""
            }
            let notesboolean = false;
            if (childItem.ORDER_DESC != null && childItem.ORDER_DESC != undefined) {
                if (childItem.ORDER_DESC.trim() != "") {
                    notesboolean = true
                }
            }
            return (

                <div className="row mx-0 mb-3 py-3 item-box align-items-center">
                    <div className="col-md-1 text-center px-0 mb-2 ">{/*CPW-167_PC_04*/}
                        {childItem.InvItemQtyCheck == true || childItem.hasBenItemVal == "T" ? null : <div className="custom-control custom-checkbox item-custom-control">
                            <input type="checkbox" className="custom-control-input " id={`FavOrder-${OrderNo}${childindex}`} checked={childItem.checked} name={`example1`} onClick={() => this.handleItemCheckbox(childItem.ISA_INTFC_LN, OrderNo)} />
                            <label className="custom-control-label" htmlFor={`FavOrder-${OrderNo}${childindex}`} />
                        </div>}
                    </div>
                    <div className="col-lg-10 col-md-10 ">
                        <div className="row align-items-center">
                            <div className="col-md-12 fav-maintence mb-3">
                                <div className="row">
                                    <label className="catalog-label col-md-12 col-lg-2 w-100">Description :</label>
                                    <div className="col-md-12 col-lg-10">
                                        <label className="item-details-value w-100 textbreakwrap">{valitemdesc}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                                        <label className="catalog-label w-100"><Trans>Item</Trans><span> </span><Trans>ID</Trans> :</label>
                                    </div>
                                    {/*[1/19/23, WW-587_PC_5, Dhevanesam R]*/}
                                    <div className="col-md-6">
                                        {childItem.MFG_ITM_ID == " " || childItem.MFG_ITM_ID == "" || childItem.MFG_ITM_ID == null || childItem.MFG_ITM_ID == undefined ?
                                            <label className="item-details-value w-10 textbreakwrap">{`NONCAT-${childItem.ISA_INTFC_LN}`}</label>
                                            : childItem.INV_ITEM_ID.includes("NONCAT") ?
                                                <label className="item-details-value w-100 textbreakwrap">{childItem.MFG_ITM_ID}</label>
                                                : <a href className="item-details-value w-100 textbreakwrap" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.showitemdetails(childindex, childItem.INV_ITEM_ID, childItem.ISA_MFG_FREEFORM, childItem.MFG_ITM_ID, childItem.VENDOR_ID, e, childItem)}>{childItem.MFG_ITM_ID}</a>}
                                        {childItem.hasBenItemVal == "C" ? <span class="i-circlegridBlue">C</span> : childItem.hasBenItemVal == "T" ? <span class="i-circlegridYellow">T</span> : childItem.VENDOR_ID == "W999999999" || childItem.SUPPLIER == "SDI Warehouse" ? <span class="i-circlegrid">w</span> : null}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="catalog-label w-100">Delivery date:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="item-details-value">{childItem.ISA_REQUIRED_BY_DT}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="catalog-label w-100">UOM:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="item-details-value">{childItem.UNIT_OF_MEASURE}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-4">
                                <div className="row">
                                    <div className="col-md-6 pr-0">
                                        <label className="catalog-label w-100">Manufacturer :</label>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="item-details-value w-100 textbreakwrap">{childItem.ISA_MFG_FREEFORM}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="catalog-label w-100">Supplier :</label>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="item-details-value">{supplierstr}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-4">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="catalog-label w-100">Supplier part#:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="item-details-value textbreakwrap">{childItem.ITM_ID_VNDR != null && childItem.ITM_ID_VNDR != "" ? childItem.ITM_ID_VNDR : childItem.INV_ITEM_ID}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-8">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6">
                                        <label className="catalog-label w-100">Install store:</label>
                                    </div>
                                    <div className="col-lg-9 col-md-6">
                                        <label className="item-details-value">{childItem.ISA_USER2}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-8">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6">
                                        <label className="catalog-label w-100">Quantity:</label>
                                    </div>
                                    <div className="col-lg-9 col-md-6">
                                        <label className="item-details-value">{childItem.QTY_REQUESTED}</label>
                                    </div>
                                </div>
                            </div>

                            {childItem.hasCoreCharge == true ? <div className="col-lg-7 col-md-7 Ipad-UI fav-maintence">
                                <label id={`Corechargelab-${OrderNo}${childindex}`} className="catalog-label" style={{ "color": "#4995f2" }}>Core Charge</label>
                            </div> : null}
                        </div>
                    </div>
                </div>

            )

        })
    }

    //[1/19/23, WW-587_PC_5, Dhevanesam R]
    //[1/25/23, WW-587_PC_7, Dhevanesam R]
    showitemdetails = (index, ItemId, manufactpartnum, mfg_std, vendor_id, event, childItem) => {
        let Itemtypevalue = ItemId.indexOf("NONCAT") > -1 ? "NONCAT" : "CAT";

        CookieService.updateLocalStorageValues("Session_Noncat", Itemtypevalue);
        CookieService.updateLocalStorageValues("ItemDetail_ItemId", ItemId);
        CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", mfg_std);
        CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", manufactpartnum);
        CookieService.updateLocalStorageValues("ItemDetail_SupplierID", vendor_id);
        let ItemData = {
            vendor_id: vendor_id,
            ItemPrice: childItem.PRICE,
            txtDesc: childItem.ITEM_DESC

        }
        if (Itemtypevalue != "NONCAT") {
            if (window.location.pathname.toLowerCase() == "/itemdetailnew") {
                this.props.history.push({
                    pathname: `\itemdetailnew`,
                    search: `?ItemId=${ItemId}&ManufacturePartNumber=${mfg_std}&ManufactureName=${manufactpartnum}&SupplierID=${vendor_id}`,
                    state: { ItemData: ItemData, origin: 'favorder', Suggesstions: true, ItemId: ItemId, ManufacturePartNumber: mfg_std, ManufactureName: manufactpartnum, SupplierID: vendor_id }
                });
                window.location.reload()
            }
            else {
                this.props.history.push({
                    pathname: `\itemdetailnew`,
                    search: `?ItemId=${ItemId}&ManufacturePartNumber=${mfg_std}&ManufactureName=${manufactpartnum}&SupplierID=${vendor_id}`,
                    state: { ItemData: ItemData, origin: 'favorder', Suggesstions: true, ItemId: ItemId, ManufacturePartNumber: mfg_std, ManufactureName: manufactpartnum, SupplierID: vendor_id }
                });
            }
            CookieService.updateLocalStorageValues("SelectedCatIndexFavOrder", this.state.SelectedCatIndex);
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Details are not available for Non-Catalog items"
            });
        }

    }

    /**
     * Ref :FOM_PC_14
     * This method is to bind the fav orders
     */
    //WAL-541_PC_27
    bindFavOrderGrid = (i, ORDER) => {
        //data-target={`#order-row-${index}`}
        // id={`order-row-${index}`}
        let catdetail = this.state.favOrderArray.filter((value, indexVal) => value.ORDER_CATEGORY == ORDER.ORDER_CATEGORY && ORDER.ORDER_SUBCATEGORY == value.ORDER_SUBCATEGORY)
        return this.state.favOrderArray.map((order, index) => {
            // if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {

            const style = {
                //WW-375 Ability to add Image to Fav Order-Deepthi
                image: {
                    position: 'sticky !important',
                    display: 'block',
                    left: '0px !important',
                    top: '0px !important',
                    marginLeft: '20px'
                },
            }
            //WW-1063 editing the image is not reflecting s.sanjay
            let imagepath = "Images\noimage_new.png";
            if (order.IMG_URL == undefined || order.IMG_URL == "" || order.IMG_URL == null) {
                imagepath = "Images\noimage_new.png";
            }
            else {
                let spliturl = order.IMG_URL.split('|');
                if (spliturl[0] === null || spliturl[0].trim() === "\\N") {
                    imagepath = "Images/noimage_new.png";
                } else {
                    imagepath = spliturl[0].trim();
                }

            }
            if (order.ORDER_CATEGORY == ORDER.ORDER_CATEGORY && ORDER.ORDER_SUBCATEGORY == order.ORDER_SUBCATEGORY) {
                let orderLineItemCount = this.state.favOrderLineItemData.filter((value, indexVal) => value.ORDER_NO == order.ORDER_NO).length;
                return (

                    <div className="w-100">
                        {/* 1st level accordion */}
                        <div className="row align-items-center py-4">
                            <div className="col-12 col-lg-1 col-md-1 p-0 mb-3">
                                <span data-toggle="collapse" id={`#Order-accordian${index}`} data-target={`#Item-accordian${index}`} aria-controls={`#Item-accordian${index}`} className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)}><span className="accordion-arrow" /></span>
                            </div>
                            <div className="col-12 col-lg-1 col-md-1 p-0 mb-3 ">
                                <div className="d-flex justify-content-center">
                                    <div className="custom-control custom-checkbox item-custom-control">
                                        <input type="checkbox" className="custom-control-input" id={`ReOrder-${index}`} name="" checked={order.ReorderCheck} onChange={e => this.handleOrderCheckbox(order.ORDER_NO)} />
                                        <label className="custom-control-label" htmlFor={`ReOrder-${index}`} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-8 col-md-6">
                                <div className="row align-items-center">
                                    <div className="col-md-7 col-lg-3 mb-3">

                                        <Image
                                            id={`Img${order.ORDER_NO}${index}id`}
                                            src={imagepath}
                                            width={100}
                                            height={100}
                                            overflow="hidden"
                                            alignItems="center"
                                            accept="image/x-png,image/gif,image/jpeg"
                                            style={style.image}
                                            noImageSrc="/Images/noimage_new.png"
                                        />
                                        {/*<img src="images/product1.jpg" alt="product_image" className="sdi-category-image" />*/}
                                        <div className="d-flex justify-content-center">
                                            <div className="sdi-edit-bg">
                                                {/*//WW-947 Attachment utility in fav order - Yuvarani K*/}
                                                <input type="file" name="input" id={`input${index}`} style={{ display: 'none' }} accept="image/jpeg, image/png, image/jpg" onChange={(e) => this.handleAttachmentImg(e, index, order.ORDER_NO)} />
                                                <label htmlFor={`input${index}`} className="sdi-edit-label mb-0">
                                                    <span>
                                                        {/*<img src="images/edit-icon.svg" id="image" className="mb-1 sdi-edit-icon-width" />*/}

                                                    </span>Edit</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-lg-9">
                                        <h4 className="sdi-category-title mb-3">{order.ORDER_NO}</h4>
                                        <div className="d-md-none d-lg-block">
                                            <div className="row">
                                                {/* <div className="col-md-6">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <label className="catalog-label w-100">Order # :</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label>{order.ORDER_NO}</label>
                                                                    </div>
                                                                </div>
                                                            </div>*/}
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <label className="catalog-label w-100">Priority :</label>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <label>{order.ISA_PRIORITY_FLAG == `R` ? `Priority` : ``}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label className="catalog-label w-100">Work order :</label>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>{order.ISA_WORK_ORDER_NO}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <label className="catalog-label w-100 pr-2">Order entered by :</label>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <label>{order.OPRID_ENTERED_BY}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label className="catalog-label w-100">Business unit :</label>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>{order.BUSINESS_UNIT}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <label className="catalog-label w-100">Ordered for :</label>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <label>{order.ORDERED_FOR}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6" style={{ wordBreak: "break-all" }}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label className="catalog-label w-100">Notes:</label>
                                                        </div>
                                                        <div className="col-md-12 favnote-wrap">
                                                            <label>{order.ORDER_DESC}</label>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-12 mb-2">
                                <div className="d-flex sdi-category-title justify-content-end">Share/Delete <input type="checkbox" className="sdi-checkbox ml-2" id={`Order-${index}`} name="" checked={order.checked} onChange={e => this.CategoryOnCheck("Item", order, order.checked)} /></div>
                            </div>
                            {/* <td class="sdi-category-image"></td> */}
                        </div>
                        {/* 1st level accordion - Ends here */}
                        <div className="row accordian-body py-5 collapse sdi-category-grid" id={`Item-accordian${index}`}>
                            <div className="col-md-12">
                                <h4 className="item-details-title-fmt">Item details</h4>
                                {this.bindFavOrderLineItems(order.ORDER_NO)}
                                <div className="text-right">
                                    {/**A1QA-248_PC_03 (11/15/2022)-Aparna**/}
                                    <button className="btn btn-primary custom-btn-primary primary-btn mb-2" onClick={() => this.addFavOrderItemsToCart(order.ORDER_NO, false, false)}>Add to cart</button>
                                </div>
                            </div>
                        </div>
                    </div>

                );
            }

        })
    };
    //WAL-541_PC_27
    bindCategory = () => {
        //  let category = this.state.favOrderArray.filter((v, i, a) => a.findIndex(t => (t.ORDER_CATEGORY=== v.ORDER_CATEGORY)) === i)
        // let category = favOrderArray
        let unclassfied = this.state.favOrderArray.filter((x) => x.ORDER_CATEGORY == "" || x.ORDER_CATEGORY == undefined || x.ORDER_CATEGORY == " " || x.ORDER_CATEGORY == null)
        console.log("unclassfied", unclassfied)

        return this.state.CategoryArr.map((order, index) => {
            // if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {

            let cat = order.ORDER_CATEGORY
            return (
                <React.Fragment key={order.ORDER_CATEGORY}>

                    <li className="card-header sdi-category-header mb-2" id={`Category-${index}`} onClick={e => this.SelectSubCategory("", order.ORDER_CATEGORY, index, order)}><div className="d-flex justify-content-between" >{order.ORDER_CATEGORY == null || order.ORDER_CATEGORY == undefined ? "UNCLASSIFIED" : order.ORDER_CATEGORY.trim() == "" ? "UNCLASSIFIED" : order.ORDER_CATEGORY}
                        <input type="checkbox" className="sdi-checkbox" id={`CategoryCheckBox-${index}`} name="" checked={order.check} onChange={e => this.CategoryOnCheck("cat", order, order.check)} /></div></li>
                </React.Fragment>

            )

            //  }

        });

    }

    SelectSubCategory = (event, cat, index, catItem) => {
        if (event == "pageLoad") {
            $(`#Category-${this.state.SelectedCatIndex}`).removeClass('sdi-category-header-active')
            $(`.sdi-category-header-active`).removeClass('sdi-category-header-active')
            //WW-542_PC_08 (12/2/2022)-Aparna
            $(`#Category-${index}`).addClass('sdi-category-header-active')
        }
        else {
            $(`.sdi-category-header-active`).removeClass('sdi-category-header-active')
            $(`#Category-${index}`).addClass('sdi-category-header-active')
            if (this.state.SelectedCatIndex != index) {
                $(`#Category-${this.state.SelectedCatIndex}`).removeClass('sdi-category-header-active')
            }
        }
        let locsubcat = []
        let filteredSubCat = []
        let count = 0
        locsubcat = this.state.favOrderLineItemData.filter((val, ind) => val.ORDER_CATEGORY == cat)
        filteredSubCat = locsubcat.filter((v, i, a) => a.findIndex(t => (t.ORDER_SUBCATEGORY === v.ORDER_SUBCATEGORY)) === i)
        if (filteredSubCat.length > 0) {
            count = filteredSubCat.length;
        }
        console.log("filteredSubCat", filteredSubCat);
        console.log("count", count);
        let countT = parseFloat(count) / 10
        this.setState({ SelectedCategory: cat, SelectedCatIndex: index, SubCategoryArr: filteredSubCat, totalCount: count, pageCount: countT, PageNo: 1 });
        if (catItem.check) {
            if (filteredSubCat != [] && filteredSubCat != undefined && filteredSubCat != null) {
                filteredSubCat.forEach((x, index) => {
                    if (x.ORDER_CATEGORY == catItem.ORDER_CATEGORY) {
                        filteredSubCat[index].SubCatcheck = true
                    }
                })
                this.setState({ SubCategoryArr: filteredSubCat });
            }
            //this.CategoryOnCheck("SubCat",cat)
        }
        else {
            if (filteredSubCat != [] && filteredSubCat != undefined && filteredSubCat != null) {
                filteredSubCat.forEach((x, index) => {
                    if (x.ORDER_CATEGORY == catItem.ORDER_CATEGORY) {
                        filteredSubCat[index].SubCatcheck = false
                    }
                })
                this.setState({ SubCategoryArr: filteredSubCat });
            }
        }
        // this.setState({ SelectedCategory: cat, SelectedCatIndex: index });
    }



    //if (unclassfied.length()>0) {
    //    return category.map((order, index) => {
    //        return ()
    //    })

    //}
    bindSubCategory = () => {
        //let cat = "";
        return this.state.SubCategoryArr.map((order, index) => {
            console.log("this.state.SubCategoryArr", this.state.SubCategoryArr)
            if (order.ORDER_CATEGORY == this.state.SelectedCategory) {
                if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                    return (
                        <React.Fragment>
                            <tr>
                                <td data-toggle="collapse" data-target={`#Order-accordian${index}`} aria-controls={`#Order-accordian${index}`} id={`SubCat-accordian${index}`} className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)}>
                                    <span id={`Span-accordian-change${index}`} className="accordion-arrow" />
                                </td>
                                <td><h4 className="font-20 mb-0 sdi-category-title">{order.ORDER_SUBCATEGORY == null || order.ORDER_SUBCATEGORY == undefined ? "UNCLASSIFIED" : order.ORDER_SUBCATEGORY.trim() == "" ? "UNCLASSIFIED" : order.ORDER_SUBCATEGORY}</h4></td>
                                <td>
                                    <div className="d-flex align-items-center"><label className="sdi-category-title mr-2 mb-0">Share/Delete </label>
                                        <div className="custom-control custom-checkbox item-custom-control mb-2">
                                            <input type="checkbox" className="custom-control-input" id={`SubCategroeyCheckbox${index}`} name="" checked={order.SubCatcheck} onChange={e => this.CategoryOnCheck("SubCat", order, order.SubCatcheck)} />
                                            <label className="custom-control-label" htmlFor={`SubCategroeyCheckbox${index}`} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr className="accordian-body collapse py-1" id={`Order-accordian${index}`}   >
                                <td colSpan={12} className="pl-5 pr-3 py-0">
                                    {this.bindFavOrderGrid(index, order)}
                                </td>
                            </tr>
                        </React.Fragment>
                    )
                }
            }

        });
    }
    bindOrderDetail = (orderparam) => {
        return this.state.favOrderArray.map((order, index) => {
            console.log("this.state.favOrderArray", this.state.favOrderArray);
            if (orderparam.ORDER_SUBCATEGORY == order.ORDER_SUBCATEGORY && orderparam.ORDER_CATEGORY == order.ORDER_SUBCATEGORY) {
                return (
                    <tr className="accordian-body collapse py-1" id="order-row-1">
                        <td colSpan={12} className="pl-5 pr-3 py-0">
                            <div className="w-100">
                                {/* 1st level accordion */}
                                <div className="row align-items-center py-4">
                                    <div className="col-12 col-lg-1 col-md-1 p-0 mb-3">
                                        <span data-toggle="collapse" data-target="#order-row-2" aria-controls="order-row-2" className="accordion-toggle"><span className="accordion-arrow" /></span>
                                    </div>
                                    <div className="col-12 col-lg-1 col-md-1 p-0 mb-3 ">
                                        <div className="d-flex justify-content-center">
                                            <div className="custom-control custom-checkbox item-custom-control">
                                                <input type="checkbox" className="custom-control-input" id="customCheck18" name="example1" />
                                                <label className="custom-control-label" htmlFor="customCheck18" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-8 col-md-6">
                                        <div className="row align-items-center">
                                            <div className="col-md-7 col-lg-3 mb-3">
                                                <img src="images/product1.jpg" alt="product_image" className="sdi-category-image" />
                                                <div className="d-flex justify-content-center">
                                                    <div className="sdi-edit-bg">
                                                        <input type="file" name="input" id="input-0" style={{ display: 'none' }} />
                                                        <label htmlFor="input-0" className="sdi-edit-label mb-0"><span><img src="images/edit-icon.svg" id="image" className="mb-1 sdi-edit-icon-width" /></span> Edit</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-lg-9">
                                                <h4 className="sdi-category-title mb-3">{order.ORDER_NO}</h4>
                                                <div className="d-md-none d-lg-block">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <label className="catalog-label w-100">Order # :</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label>{order.ORDER_NO}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row">
                                                                <div className="col-md-7">
                                                                    <label className="catalog-label w-100">Priority :</label>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <label>-</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <label className="catalog-label w-100">Work order :</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label>178999659</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row">
                                                                <div className="col-md-7">
                                                                    <label className="catalog-label w-100">Order entered by :</label>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <label>SDIUSER</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <label className="catalog-label w-100">Business unit :</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label>I0W01</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row">
                                                                <div className="col-md-7">
                                                                    <label className="catalog-label w-100">Ordered for :</label>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <label>SDIUSER</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 mb-2">
                                        <div className="d-flex sdi-category-title">Share/Delete <input type="checkbox" className="sdi-checkbox ml-2" /></div>
                                    </div>
                                    {/* <td class="sdi-category-image"></td> */}
                                </div>
                                {/* 1st level accordion - Ends here */}
                                <div className="row accordian-body py-5 collapse sdi-category-grid" id="order-row-2">
                                    <div className="col-md-12">
                                        <h4 className="item-details-title">item details</h4>
                                        <div className="row mx-0 mb-3 py-3 item-box align-items-center">
                                            <div className="col-md-1 text-center px-0 mb-2">
                                                <div className="custom-control custom-checkbox item-custom-control">
                                                    <input type="checkbox" className="custom-control-input" id="customCheck18" name="example1" />
                                                    <label className="custom-control-label" htmlFor="customCheck18" />
                                                </div>
                                            </div>
                                            <div className="col-lg-10 col-md-10 ">
                                                <div className="row align-items-center">
                                                    <div className="col-md-12 fav-maintence mb-3">
                                                        <div className="row">
                                                            <label className="catalog-label col-md-12 col-lg-2 w-100">Description :</label>
                                                            <div className="col-md-12 col-lg-10">
                                                                <label className="item-details-value w-100">HOOK, CLOTHES, DOUBLE WITH SCREWS, ALUMINUM BRIGHT
                                                    FINISH, WIDTH: 2-7/8 INCH</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-lg-4">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label className="catalog-label w-100"> <Trans>Item</Trans><span> </span><Trans>ID</Trans> :</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="item-details-value">34GR19</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-lg-4">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label className="catalog-label w-100">Delivery date:</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="item-details-value">10/19/2022</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-lg-4">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label className="catalog-label w-100">UOM:</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="item-details-value">EA</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-lg-4">
                                                        <div className="row">
                                                            <div className="col-md-6 pr-0">
                                                                <label className="catalog-label w-100">Manufacturer :</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="item-details-value">DEWALT</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-lg-4">
                                                        <div className="row">
                                                            <div className="col-md-6 pt-2">
                                                                <label className="catalog-label w-100">Supplier :</label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label className="item-details-value">W W Grainger</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-lg-8">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-6">
                                                                <label className="catalog-label w-100">Install store:</label>
                                                            </div>
                                                            <div className="col-lg-9 col-md-6">
                                                                <label className="item-details-value">Walmart Store #560 - W00560</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-right">
                                            <button className="btn btn-primary custom-btn-primary primary-btn mb-2">Add to cart</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                )
            }
        });
    }
    /**
     * This method will be invoked on selecting filter column names
     * @param event,@param displayName,@param columnName
     */
    filterClick = (event, displayName, columnName) => {
        event.preventDefault();
        this.setState({ filterDisplayName: displayName, searchColumn: columnName });
        if (displayName == `Priority`) {
            $("#searchTxt").hide();
            $("#searchIcon").hide();
            $("#priorityDiv").show();
            //this.setState({ priorityFlag: 0 });
        } else {
            $("#searchTxt").show();
            $("#searchIcon").show();
            $("#priorityDiv").hide();
        }

    };

    handleEquipmentYes = () => {
        $('#FavOrderMixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        this.addFavOrderItemsToCart(this.state.favOrder, this.state.CoreCharge, this.state.Proceed);
    };

    handleEquipmentNo = () => {
        $('#FavOrderMixedOrderConfirmPopup').modal('hide'); // Hide the equipment modal
        cartDelete = false;
    };

    /**
     * Ref: FOM_PC_18
     * This method will be invoked on clicking Reorder button
     * @param ORDER_NO
     */
    /**
     * A1QA-248_PC_02
     * 
     * */
    addFavOrderItemsToCart = (ORDER_NO, CoreCharge, Proceed) => {

        //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            let hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === "Equipment");
            let hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
            if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
                $('#FavOrderMixedOrderConfirmPopup').modal('show');
                this.setState({ favOrder: ORDER_NO, CoreCharge: CoreCharge, Proceed: Proceed, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" })
                return;
            }
            else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
                $('#FavOrderMixedOrderConfirmPopup').modal('show');
                this.setState({ favOrder: ORDER_NO, CoreCharge: CoreCharge, Proceed: Proceed, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" })
                return;
            }
        }
        let itemsSelected = this.state.favOrderLineItemData.filter((favOrder) => favOrder.checked == true && favOrder.ORDER_NO == ORDER_NO);
        // WW -295_PC_02 - removing quntity check for reordering (12/16/2021) - Aparna
        //let isQuantityPresent = itemsSelected.filter((x) => x.QTY_REQUESTED == "").length == 0 ? true : false;
        //if (!isQuantityPresent) {
        //    alert("Please enter quantity for the selected line items");
        //    return false;
        //}
        let itemsToAdd = [];
        let LochasCoreCharge = false;
        console.log("itemsSelected", itemsSelected)
        let itemIDArr = [];
        let favItemID = "";
        let TruckStock = false //CPW-167_PC_07
        if (itemsSelected.length > 0) {// && isQuantityPresent) { 

            itemsSelected.forEach((value, index) => {
                itemIDArr.push(value.INV_ITEM_ID)
            });
            favItemID = itemIDArr.join(",")

            if (CoreCharge == false) {
                itemsSelected.forEach((value) => {
                    if (value.hasBenItemVal != "T") {
                        if (value.hasCoreCharge) {
                            CoreCharge = true
                            LochasCoreCharge = true
                        }

                        itemsToAdd.push({
                            Order_Number: value.ORDER_NO,
                            Business_unit_om: value.BUSINESS_UNIT_OM,
                            INV_ITEM_ID: value.INV_ITEM_ID,
                            Quantity: value.QTY_REQUESTED,
                            ISA_INTFC_LN: value.ISA_INTFC_LN,
                            MFG_ITM_ID: value.MFG_ITM_ID,
                            ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM,
                            Descr: value.DESCR254,
                            price: value.ISA_SELL_PRICE,
                            ITEM_CAT: value.ISA_ITEM_CAT,
                            PaintColor: value.LINE_FIELD_C6
                        });
                    }
                    else {
                        TruckStock = true
                    }

                });
            }
            else {
                itemsSelected.forEach((value) => {
                    if (value.hasBenItemVal != "T") {
                        if (Proceed == true) {
                            itemsToAdd.push({
                                Order_Number: value.ORDER_NO,
                                Business_unit_om: value.BUSINESS_UNIT_OM,
                                INV_ITEM_ID: value.INV_ITEM_ID,
                                Quantity: value.QTY_REQUESTED,
                                ISA_INTFC_LN: value.ISA_INTFC_LN,
                                MFG_ITM_ID: value.MFG_ITM_ID,
                                ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM,
                                Descr: value.DESCR254,
                                price: value.ISA_SELL_PRICE,
                                ITEM_CAT: value.ISA_ITEM_CAT,
                                PaintColor: value.LINE_FIELD_C6

                            });
                        }
                        else {
                            if (value.hasCoreCharge == false) {
                                itemsToAdd.push({
                                    Order_Number: value.ORDER_NO,
                                    Business_unit_om: value.BUSINESS_UNIT_OM,
                                    INV_ITEM_ID: value.INV_ITEM_ID,
                                    Quantity: value.QTY_REQUESTED,
                                    ISA_INTFC_LN: value.ISA_INTFC_LN,
                                    MFG_ITM_ID: value.MFG_ITM_ID,
                                    ISA_MFG_FREEFORM: value.ISA_MFG_FREEFORM,
                                    Descr: value.DESCR254,
                                    price: value.ISA_SELL_PRICE,
                                    ITEM_CAT: value.ISA_ITEM_CAT,
                                    PaintColor: value.LINE_FIELD_C6
                                });
                            }
                        }
                    } else {
                        TruckStock = true
                    }

                });
            }


            //let cartstorage = []
            //if (localStorage.getItem("CartStorage") != null) {
            //    cartstorage = JSON.parse(localStorage.getItem("CartStorage"));
            //}
            //console.log("cartstorage", cartstorage);
            //let cartcontain = false
            //if (cartstorage.length > 0) {
            //    cartstorage.map((x) => {
            //        //WW-419_BUG_2282_PC_01 -Aparna
            //        if (x.Itemid.includes("NONCAT")) {
            //            let ind = itemsSelected.findIndex(y => x.ItemDescription.toLowerCase() == y.DESCR254.toLowerCase() && x.Manufacturer.toLowerCase() == y.ISA_MFG_FREEFORM.toLowerCase() && x.Manufacturerpartnumber.toLowerCase() == y.MFG_ITM_ID.toLowerCase());
            //            if (ind != -1) {
            //                itemsSelected.splice(ind, 1)
            //                itemsToAdd.splice(ind, 1)
            //            }
            //        }
            //        else {
            //            let ind = itemsSelected.findIndex(y => x.Itemid.toLowerCase() == y.INV_ITEM_ID.toLowerCase() && x.Manufacturer.toLowerCase() == y.ISA_MFG_FREEFORM.toLowerCase() && x.Manufacturerpartnumber.toLowerCase() == y.MFG_ITM_ID.toLowerCase());
            //            if (ind != -1) {
            //                itemsSelected.splice(ind, 1)
            //                itemsToAdd.splice(ind, 1)
            //            }
            //        }

            //    })
            //}
            if (CoreCharge == true && Proceed == false && LochasCoreCharge == true) {
                $('#CoreChargePopUp').modal('show')
                this.setState({ CoreChargeOrderNo: ORDER_NO });
                return;
            }

            if (itemsSelected.length > 0 && itemsToAdd.length > 0) {
                let addFavOrderItemsBO = {
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                    LineItems: itemsToAdd,
                    /*[12/24/21, PC_SC_17], Priyanka D//Passing the Location value */
                    Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
                    Session_ID: CookieService.getLocalStorageValues("Session_ID"),//WW-390_PC_08 (4/20/2022)-Aparna
                    Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
                    EquipmentDelete: cartDelete,
                    Interactive: false
                };
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                FavOrderMainAction.addFavOrderItemsTocart(addFavOrderItemsBO);
            }

            else {
                if (TruckStock) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Truck stock item cannot be added to cart."
                    });
                } else if (CoreCharge && !Proceed) {
                    $('#CoreChargePopUp').modal('hide')
                } else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please select line items to reorder."
                    });
                }

                // alert("Item already exsist");
            }
        }

        else {

            if (TruckStock) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Truck stock item can not be added to cart."
                });
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select line items to reorder"
                });
            }
            // alert("Please select line items to reorder");
        }
    };
    //WAL-541_PC_21 -Aparna
    SortingCat = (sort, name) => {
        //BUG_2570    (9/2/2022)-Aparna
        let data = this.state.CategoryArr;
        if (sort == "D") {

            data = this.state.CategoryArr.sort((a, b) => (a.ORDER_CATEGORY > b.ORDER_CATEGORY) ? 1 : -1);

        }
        //BUG_2570    (9/2/2022)-Aparna
        else if (sort == "A") {

            data = this.state.CategoryArr.sort((a, b) => (b.ORDER_CATEGORY > a.ORDER_CATEGORY) ? 1 : -1);

        }

        this.setState({ GridArr: data, sortVal: sort })
    }
    //WAL-714_PC
    SharedIconClick = (OrderNo, level, catname) => {
        //Update (3/29/2022)
        let CatShare = [];
        if (level == "cat") {
            let shareorderdetail = this.state.favOrderLineItemData.filter((x) => x.ORDER_CATEGORY == catname)
            if (shareorderdetail != undefined || shareorderdetail != null) {
                shareorderdetail.forEach((x, i) => {
                    CatShare.push(x)
                })
            }
            this.setState({ CategoryShare: CatShare });
        }
        else {
            this.setState({ SharededOrderNO: OrderNo });
        }


    }
    //WAL-714_PC
    HandleOnChange = (event, name, index) => {
        switch (name) {
            case "SelectedRegion": {
                let emp = []
                if (event != null) {
                    this.state.EMPDD.map((val, index) => {
                        if (event.value == val.REGION) {
                            if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                                let localArray = {
                                    value: val.EMP_ID,
                                    label: val.ISA_EMPLOYEE_NAME + "  " + val.ISA_EMPLOYEE_EMAIL
                                }

                                emp.push(localArray)
                            }
                        }

                    });

                }
                // WAL -714_PC_UserDD_02
                else {
                    this.state.EMPDD.map((val, index) => {
                        if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                            let localArray = {
                                value: val.EMP_ID,
                                label: val.ISA_EMPLOYEE_NAME + "  " + val.ISA_EMPLOYEE_EMAIL
                            }
                            emp.push(localArray)
                        }
                    });

                }
                this.setState({ [name]: event, UserDD: emp, SelectedUser: [] });

                break;
            }
            case "SelectedUser": {
                let selectedPC = [];
                let selectedpclength = this.state.UserDD.length
                let pclenght = this.state.UserDD
                let eventlength = event.lastIndexOf()

                event.forEach((val, ind) => {
                    if (event[ind].value == "*") {

                        selectedPC = []
                        this.state.UserDD.forEach((x, i) => {

                            //let localArray = {
                            //    value: x.value,
                            //    label: x.ISA_PROBLEM_CODE
                            //}
                            selectedPC.push(x);

                        })
                        return true;
                    }
                    else {
                        selectedPC.push(val);
                    }


                })
                this.setState({ SelectedUser: selectedPC });
                break;
            }


        }

    }
    //WAL-714
    ShareButtonClick = () => {
        let empids = []
        let shareorderdetail = []
        this.state.SelectedUser.forEach((x) => {
            empids.push(x.value)
        })
        //if (this.state.CategoryShare != undefined && this.state.CategoryShare != null && this.state.CategoryShare != []) {
        //    if (this.state.CategoryShare.length > 0) {
        //        shareorderdetail = this.state.CategoryShare
        //    }
        //} else {
        //    shareorderdetail = this.state.favOrderLineItemData.filter((x) => x.ORDER_NO == this.state.SharededOrderNO)
        //}
        if (empids.length > 0) {


            let shareorder = this.state.favOrderArray.filter((x) => x.checked == true)
            shareorder.forEach((x) => {
                this.state.favOrderLineItemData.forEach((y) => {
                    if (x.ORDER_NO == y.ORDER_NO) {

                        //WW-947 Attachment utility in fav order - Yuvarani K
                        y.ORDERED_FOR = x.ORDERED_FOR;
                        shareorderdetail.push(y)
                    }

                })

            })

            console.log("shareorderdetail", empids);
            console.log("SelectedUser", this.state.SelectedUser);
            console.log("CategoryShare", this.state.CategoryShare);
            let OrderDetails = [];
            shareorderdetail.forEach((x, i) => {
                OrderDetails.push({
                    OrderNo: shareorderdetail[i].ORDER_NO,
                    EmployeeID: shareorderdetail[i].ISA_EMPLOYEE_ID,
                    BusinessUnit: shareorderdetail[i].BUSINESS_UNIT_OM,
                    OrderEnteredFor: shareorderdetail[i].OPRID_ENTERED_BY,
                    OrderedFor: shareorderdetail[i].ORDERED_FOR,
                    WorkOrder: shareorderdetail[i].ISA_WORK_ORDER_NO,
                    Priority: shareorderdetail[i].ISA_PRIORITY_FLAG,
                    OrderCategory: shareorderdetail[i].ORDER_CATEGORY != undefined && shareorderdetail[i].ORDER_CATEGORY != null ? shareorderdetail[i].ORDER_CATEGORY.replaceAll("'", "''") : "UNCLASSIFED",
                    OrderSubCategory: shareorderdetail[i].ORDER_SUBCATEGORY != undefined && shareorderdetail[i].ORDER_SUBCATEGORY != null ? shareorderdetail[i].ORDER_SUBCATEGORY.replaceAll("'", "''") : "UNCLASSIFED",
                    OrderDescription: shareorderdetail[i].ORDER_DESC != undefined && shareorderdetail[i].ORDER_DESC != null ? shareorderdetail[i].ORDER_DESC.replaceAll("'", "''") : "",
                    //PC-1063-01 adding the image url S.Sanjay 07/22/2024
                    OrdImg: shareorderdetail[i].IMG_URL
                })
            })

            let BO = {
                FavOrders: OrderDetails,
                EmpIds: empids
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            FavOrderMainAction.ShareButtonClickAction(BO);
        }
        else {
            document.getElementById('usererror').innerHTML = "Please select user"
        }

    }
    //WAL-714
    ShareButtonClickResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //console.error('Share-err')

        //WW-947 Attachment utility in fav order - Yuvarani K
        console.log(FavOrderMainStore.shareResponse);
        let SharedResponse = FavOrderMainStore.pageLoadData
        console.error('Shareerr', SharedResponse)
        $(`#searchTxt`).val("");
        if (SharedResponse == "Success") {
            this.setState({ SelectAll: true })

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Shared successfully"
            });
            //  alert("shared successfully");
            $('#Fav_Order_Sharing').modal('hide');


            let locEMP = [];
            this.state.EMPDD.forEach((val, index) => {
                if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                    let localArray = {
                        value: val.EMP_ID,
                        label: val.ISA_EMPLOYEE_NAME + " " + val.ISA_EMPLOYEE_EMAIL
                    }

                    locEMP.push(localArray)
                }
            });
            this.pageLoad(this.state.pageNo,
                this.state.itemCount,
                "",
                "",
                this.state.sortColumn,
                this.state.sortValue
            );

            // window.location.reload(true)
            document.getElementById('usererror').innerHTML = ""

            this.setState({ SelectedUser: [], SelectedRegion: [], UserDD: locEMP })
            let Response = JSON.parse(FavOrderMainStore.pageLoadData);

            console.log("share resposne", Response);
        }

        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Oops, Something went wrong"
            });
            $('#Fav_Order_Sharing').modal('hide');
        }
    }




    //WAL-714
    Fav_Order_Share_Close = () => {
        let locEMP = [];
        this.state.EMPDD.forEach((val, index) => {
            if (val.EMP_ID != CookieService.getLocalStorageValues("Session_UserID")) {
                let localArray = {
                    value: val.EMP_ID,
                    label: val.ISA_EMPLOYEE_NAME + " " + val.ISA_EMPLOYEE_EMAIL
                }

                locEMP.push(localArray)
            }
        });
        document.getElementById('usererror').innerHTML = ""
        this.setState({ SelectedRegion: [], SelectedUser: [], UserDD: locEMP, CategoryShare: [] });
    }
    //WAL-714 update
    ShareMultipleItems = () => {
        let filteritem = this.state.favOrderArray.filter((x) => x.checked == true)
        if (filteritem.length > 0) {
            $('#Fav_Order_Sharing').modal('show');
            document.getElementById('usererror').innerHTML = ""
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select any category / order"
            });
            // alert("Select any category / order");
        }

    }
    //WW-419_PC_13
    DeleteButtonClick = () => {
        let shareorder = this.state.favOrderArray.filter((x) => x.checked == true)
        if (shareorder.length > 0) {
            $('#Cancel-confirmation').modal('show');
            this.setState({ multiDelete: true });
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select any Order/Category"
            });
            //alert("Select any Order/Category")
        }

    }
    //WW-419_PC_15
    DeleteMultipleOrder = () => {
        let UpdateFavOrder = [];
        let shareorder = this.state.favOrderArray.filter((x) => x.checked == true)
        shareorder.forEach((x) => {
            let loc = {
                FAV_ORDER_ID: x.FAV_ORDER_ID
            }
            UpdateFavOrder.push(loc)
        })
        if (UpdateFavOrder.length > 0) {
            let BO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Orders: UpdateFavOrder
            }
            $('#Cancel-confirmation').modal('hide');
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            this.refreshMenu();
            FavOrderMainAction.DeleteButtonClickAction(BO);

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select Orders to Delete"
            });

            //   alert("Select Orders to Delete")

        }

    }
    //WW-419_PC_16
    DeleteMultipleOrderResponse() {
        

        let response = FavOrderMainStore.deleteresponse

        if (response == "success") {

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Deleted successfully"
            });
            //   alert("Deleted successfully")
            this.pageLoad(this.state.pageNo,
                this.state.itemCount,
                "",
                "",
                this.state.sortColumn,
                this.state.sortValue
            );
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "please try again"
            });
            //  alert("please try again");
        }

    }
    DeleteConfirmationNo = () => {
        this.setState({ multiDelete: false });
    }
    bindCategoryMob = () => {


        return this.state.CategoryArr.map((order, index) => {
            // if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {

            let cat = order.ORDER_CATEGORY
            return (

                <option value={order.ORDER_CATEGORY}>{order.ORDER_CATEGORY}</option>


            )

            //  }

        });

    }
    mobcatchange = (event) => {
        this.SelectSubCategory("", event.target.value, 0)
    }
    CoreChargePopUpclose = (e) => {
        
        $('#CoreChargePopUp').modal('hide');
        this.setState({ showCoreCharge: false });

    }
    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="container-fluid content-section">
                    <div className="row">
                        {/* Title - Starts here */}
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title">Favorite Order Maintenance</h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-1">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="row float-right align-items-center px-3 mb-3">
                                <div className="input-group dropdown-search mr-2 mb-2">
                                    <div className="input-group-prepend">
                                        <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" id="filterButton" aria-expanded="false" ><Trans>{this.state.filterDisplayName}</Trans></button>
                                        <div className="dropdown-menu" style={{}}>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "All", "ALL")}><Trans>All</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Order #", "ORDER_NO")}><Trans>order_key</Trans>#</a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Work Order", "ISA_WORK_ORDER_NO")}><Trans>workorder_key</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Business Unit", "BUSINESS_UNIT")}><Trans>Business</Trans><span> </span><Trans>Unit</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Priority", "ISA_PRIORITY_FLAG")}><Trans>Priority</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Order Entered by", "OPRID_ENTERED_BY")}><Trans>orderenteredby_key</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Ordered For", "ORDERED_FOR")}><Trans>orderedfor_key</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Category", "ORDER_CATEGORY")}><Trans>Category</Trans></a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.filterClick(e, "Sub Category", "ORDER_SUBCATEGORY")}><Trans>Sub Category</Trans></a>
                                        </div>
                                    </div>
                                    <input type="text" className="form-control" placeholder="Search" id="searchTxt" aria-label="Text input with dropdown button" onKeyDown={this.keyPress} onChange={this.handleSearchTxt} />
                                    <span className="dropdown-search-icon" onClick={() => this.handleSearch(false, "")} id="searchIcon" />
                                    <div className="float-left pl-0 priority-dropdown" id="priorityDiv">
                                        <label className="custom-radiobtn"><Trans>Priority</Trans>
                                            <input type="radio" checked={this.state.priorityFlag == 1 ? true : false} value="1" name="priorityOption" onChange={() => this.handlePriority(1)} />
                                            <span className="checkmark checkmark-org" />
                                        </label>
                                        <label className="custom-radiobtn"><Trans>Non-priority</Trans>
                                            <input type="radio" checked={this.state.priorityFlag == 2 ? true : false} value="2" name="priorityOption" onChange={() => this.handlePriority(2)} />
                                            <span className="checkmark checkmark-org" />
                                        </label>
                                    </div>


                                </div>
                                {this.state.totalCount != 0 ?
                                    <div>
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.ShareMultipleItems()}>Share</button>

                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.DeleteButtonClick()}>Delete</button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(event) => this.SelectAllButtonClick(event, this.state.SelectAll)}>
                                            {this.state.SelectAll ? <Trans>Select All Category</Trans> : <Trans>Unselect All Category</Trans>}</button> </div> : null}
                            </div>
                            {this.state.totalCount != 0 ? <div className="row mb-3">
                                <div className="d-md-none d-lg-none d-sm-block col-md-3">
                                    <label className="sdi-category-title">Select Category</label>
                                    <select className="sdi-category-dropdown form-control" value={this.state.SelectedCategory} onChange={e => this.mobcatchange(e)}>

                                        {this.bindCategoryMob()}

                                    </select>
                                </div>
                            </div> : null}
                        </div>


                        {this.state.totalCount != 0 ?
                            <div className="col-md-12">
                                <div className="col-md-12">
                                    <div className=" text-center ">
                                        <span style={{ fontSize: "15px" }}>Cart items quantity will be updated when it is already available in the cart</span>
                                    </div>
                                </div>
                            </div> : null}
                        {this.state.totalCount != 0 ?
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-sm-4 col-md-4 col-lg-3 my-3 mobile-filter">
                                        <div id="accordion" className="accordion-container filters-search">
                                            <div className="sdi-fav-category-container filters-search">
                                                <h6 className="accordion-title mb-0">Category</h6>
                                                <ul className="card border-0 list-unstyled sdi-container-padding AG-category-scroll" >
                                                    {this.state.isPageLoadedOnce && this.state.totalCount > 0 ? this.bindCategory() : null}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 col-md-8 col-lg-9 mt-3">
                                        <div className="row px-3">
                                            <div className="w-100 sdi-outerframe-style">
                                                <div className="col-md-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-lg-6 mb-2">
                                                            {/* Filter popup */}
                                                            <span className="float-right mb-3 d-none">
                                                                <a href="#" className="mt-2 mx-2 category-icon-toggle">
                                                                    <img src="images/category-icon.svg" alt="category Icon" className="sdi-category-icon-width" />
                                                                </a>
                                                            </span>
                                                            {/* Filter popup */}
                                                            <label className="search-category title-font m-0">Selected category :</label>
                                                            <span className="list-count ml-2">{this.state.SelectedCategory}</span>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="d-flex justify-content-end">
                                                                {this.state.totalCount == 0 ? null : (<div className="col-md-12">

                                                                    {this.state.totalCount > this.state.itemCount ? <ReactPaginate
                                                                        previousLabel={<span className="right-pagination-arrow" />}
                                                                        nextLabel={<span className="left-pagination-arrow" />}
                                                                        previousClassName={'page-item'}
                                                                        nextClassName={'page-item'}
                                                                        previousLinkClassName={'page-link'}
                                                                        nextLinkClassName={'page-link'}
                                                                        disabledClassName={'disabled'}
                                                                        breakLabel={'...'}
                                                                        breakClassName={'page-item'}
                                                                        breakLinkClassName={'page-link'}
                                                                        pageCount={this.state.pageCount}
                                                                        marginPagesDisplayed={1}
                                                                        pageRangeDisplayed={2}
                                                                        onPageChange={this.handlePageClick}
                                                                        containerClassName={'custom-pagination pagination float-right'}
                                                                        pageClassName={'page-item'}
                                                                        pageLinkClassName={'page-link'}
                                                                        activeClassName={'active'}
                                                                        hrefBuilder={() => '#'}
                                                                        forcePage={this.state.pageNo - 1}
                                                                    /> : null}

                                                                </div>)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="table-responsive">
                                                        <table className="table ZEUS_Grid sdi-FOM-grid mobileresponsive-grid">
                                                            <tbody>
                                                                {this.state.SelectedCategory != "" ? this.bindSubCategory() : null}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : <section className="site-undercontruction container text-center center-panel-1">
                                <div className="img-section">
                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                </div>
                                <p className="search-result-content pt-4">No Records found
                                            </p>
                            </section>}

                    </div>
                </div>
                <div className="modal" id="Cancel-confirmation" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                {/*<button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
                                  </button>*/}
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon delete-confirm-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Do you want to remove this order ?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.DeleteConfirmationNo()}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={this.state.multiDelete == true ? this.DeleteMultipleOrder : this.deleteFavOrder}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/**WAL-714*/}
                <div className="modal userid" id="Fav_Order_Sharing" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog  custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Share</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.Fav_Order_Share_Close()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-10 float-left mt-2">
                                        <label className="float-left col-md-3 form-label catalog-label pl-0"><Trans>Region</Trans></label>
                                        <div id=" RegionDD">
                                            <Select
                                                className="DropDown-Font-Size"
                                                options={this.state.RegionDD}
                                                value={this.state.SelectedRegion}

                                                onChange={e => this.HandleOnChange(e, "SelectedRegion")}
                                                isClearable={true}
                                                name="REG"

                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-10 float-left mt-4 ">
                                        <label htmlFor="UserDDHTML" className="float-left form-label catalog-label pl-0">User</label>
                                        <div id="UserDD">
                                            <MultiSelect
                                                options={this.state.UserDD}
                                                className="DropDown-Font-Size UserCSS w-100"
                                                id="userdd"
                                                value={this.state.SelectedUser}
                                                onChange={e => this.HandleOnChange(e, "SelectedUser")}
                                                labelledBy={"Select"}

                                            />
                                        </div>

                                    </div>
                                    <div className="col-md-6 float-left mb-2">
                                        <span className="errorspan1" style={{ fontSize: '14px', marginRight: '39%' }} id="usererror" />
                                    </div>
                                    {/*<div className="col-md-10 float-left my-5">
                                        <label className="float-left col-md-3 form-label catalog-label pl-0"><Trans>User</Trans></label>
                                        <div id="DD">
                                            <MultiSelect
                                                options={this.state.UserDD}
                                                className="w-100 DropDown-Font-Size"
                                                id="PC"
                                                value={this.state.SelectedUser}
                                                onChange={e => this.HandleOnChange(e, "SelectedUser")}
                                                labelledBy={"Select"}

                                            />
                                        </div>
                                    </div>*/}
                                </div>
                                <div className="col-md-12 text-center mb-2">

                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2 mt-5" onClick={() => this.ShareButtonClick()}><Trans>OK</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/**A1QA-248_PC_04**/}
                <div className="modal" id="CoreChargePopUp">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            {/* <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}>
                                    X
              </button>
                            </div>*/}
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block"><Trans>The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.</Trans></label>
                                        <label className="confirm-content d-block"><Trans>By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.addFavOrderItemsToCart(this.state.CoreChargeOrderNo, true, false)}><Trans>Cancel</Trans></button>{/**Added SelectedItemForCheaper to addtocart (which throwed exception)(9/5/2022)-Aparna*/}
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.addFavOrderItemsToCart(this.state.CoreChargeOrderNo, true, true)}><Trans>Proceed</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
                <div className="modal fade p-0" id="FavOrderMixedOrderConfirmPopup" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    Confirmation
                                    </h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                {this.state.cartConfirmationPopupTxt}
                            </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                    type="button"
                                    data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  >No</button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                    type="button">Yes</button>

                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}
            </React.Fragment>
        );

    }

}
export default withTranslation()(FavOrderMainComponent);